import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaStore,
  FaShoppingBasket,
  FaMotorcycle,
  FaSeedling,
} from "react-icons/fa";
import MyNavbar from "../../../components/general/navbar/MyNavbar";
import "../../../assets/css/components/general/roleSelect/RoleSelect.css";

const roles = [
  {
    icon: <FaStore />,
    title: "Seller Login",
    description: "Sell your fresh crops and products directly",
    path: "/seller/login",
    registerPath: "/seller/register",
    colorClass: "role-card--seller",
  },
  {
    icon: <FaShoppingBasket />,
    title: "Customer Login",
    description: "Access your orders and shopping history",
    path: "/customer/login",
    registerPath: "/customer/register",
    colorClass: "role-card--customer",
  },
  {
    icon: <FaMotorcycle />,
    title: "Deliveryman Login",
    description: "Manage your daily pickups and deliveries",
    path: "/delivery/login",
    registerPath: "/delivery/register",
    colorClass: "role-card--delivery",
  },
];

const RoleSelect = () => {
  const navigate = useNavigate();

  const handleRoleClick = (role) => {
    navigate(role.path);
  };

  return (
    <>
      <MyNavbar />

      <div className="rs-page">
        <div className="rs-blob rs-blob--tl" />
        <div className="rs-blob rs-blob--br" />

        <Container className="rs-wrapper">
          {/* Top Logo Icon */}
          <div className="rs-hero-icon">
            <FaSeedling />
          </div>

          {/* Heading */}
          <h1 className="rs-heading">
            Welcome Back to <span>KisaanMart</span>
          </h1>

          <p className="rs-subheading">Select your role to continue</p>

          {/* Role Cards */}
          <Row className="g-3 rs-roles justify-content-center">
            {roles.map((role, i) => (
              <Col key={i} xs={12} sm={6} lg={4}>
                <div className={`role-card ${role.colorClass}`}>
                  <div className="role-card__icon-wrap">
                    <span className="role-card__icon">{role.icon}</span>
                  </div>

                  <h3 className="role-card__title">{role.title}</h3>

                  <p className="role-card__desc">{role.description}</p>

                  <button
                    className="role-card__btn"
                    onClick={() => handleRoleClick(role)}
                  >
                    Login
                  </button>

                  <p className="role-card__register">
                    Don't have an account?{" "}
                    <span
                      className="role-card__register-link"
                      onClick={() => navigate(role.registerPath)}
                    >
                      Register
                    </span>
                  </p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </>
  );
};

export default RoleSelect;
